<template>
  <div class="content">
    <div class="content-container">
      <component :is="currentComponent" :key="$route.name" />
    </div>
    <NavInternal :links="links" />
  </div>
</template>

<script lang="ts">
import NavInternal from '@/components/NavInternal.vue'
import BannerVerbalIdentityImageSection from '@/components/VerbalIdentityPage/sections/BannerVerbalIdentityImageSection.vue'
import PraticeBannerSection from '@/components/VerbalIdentityPage/sections/in-pratice/PraticeBannerSection.vue'
import PersonaBannerSection from '@/components/VerbalIdentityPage/sections/persona/PersonaBannerSection.vue'
import SummaryBannerSection from '@/components/VerbalIdentityPage/sections/summary/SummaryBannerSection.vue'
import ToneBannerSection from '@/components/VerbalIdentityPage/sections/tone/ToneBannerSection.vue'
import VozBannerSection from '@/components/VerbalIdentityPage/sections/voz/VozBannerSection.vue'
import ContentBannerSection from '@/components/VerbalIdentityPage/sections/content/ContentBannerSection.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    NavInternal,
    PersonaBannerSection,
    VozBannerSection,
    ToneBannerSection,
    SummaryBannerSection,
    ContentBannerSection
  }
})
export default class VerbalIdentityView extends Vue {
  private routeComponentMap: { [key: string]: any } = {
    'identidade-verbal': BannerVerbalIdentityImageSection,
    'identidade-verbal.persona': PersonaBannerSection,
    'identidade-verbal.voz': VozBannerSection,
    'identidade-verbal.tom': ToneBannerSection,
    'identidade-verbal.na-pratica': PraticeBannerSection,
    'identidade-verbal.resumindo': SummaryBannerSection,
    'identidade-verbal.conteudo': ContentBannerSection
  }

  links = [
    { name: 'identidade-verbal', label: 'Identidade Verbal' },
    { name: 'identidade-verbal.persona', label: 'Persona' },
    { name: 'identidade-verbal.voz', label: 'Voz' },
    { name: 'identidade-verbal.tom', label: 'Tom' },
    { name: 'identidade-verbal.na-pratica', label: 'Na Prática' },
    { name: 'identidade-verbal.conteudo', label: 'Conteúdo' },
    { name: 'identidade-verbal.resumindo', label: 'Resumindo' }
  ]

  get currentComponent() {
    return this.routeComponentMap[this.$route.name as string] || BannerVerbalIdentityImageSection
  }
}
</script>

<style lang="scss">
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .content-container{
    width: 100%;
  }
}
</style>
